import { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import { Box } from '@mui/material';

import { Activity } from "interfaces/ActivityInterfaces";
import PaxQtySelector from "components/activity-display/control-header/PaxQtySelector";
import CloseButton from "components/shared/CloseButton";

import ActivityContent from 'components/activity-display/ActivityContent';
import { useBusiness } from 'hooks/useBusiness';
import { useUI } from 'hooks/useUI';

interface ActivityDialogProps {
	selectedActivity: Activity;
	handleClose: () => void;
}

function ActivityDialog({ selectedActivity, handleClose }: ActivityDialogProps) {
    const [scrollContainerNode, setScrollContainerNode] = useState<HTMLDivElement | null>(null);
	const { setPageTitle } = useBusiness();
	const { isSizeOrLess } = useUI();

	const isXS = isSizeOrLess('xs');

	setPageTitle(selectedActivity.title);

	return (
		<>
			<Dialog
				open={!!selectedActivity}
				onClose={handleClose}
				maxWidth="lg"
			>
				{selectedActivity && (
				<>
					<DialogTitle>
						<Grid container justifyContent="space-between" alignItems="center" wrap="nowrap" spacing={2}>
							<Grid xs={true} container alignItems="center">
								<Box
									sx={{
										display: 'flex',
										alignItems: "center",
										width: '100%',
										paddingBottom: {
											xs: '10px',
											sm: 0
										},
										paddingTop: {
											xs: '5px',
											sm: 0
										},
										gap: {
											xs: 2,
											sm: 5
										},
										flexDirection: {
											xs: 'column',
											sm: 'row'
										}
									}}
								>
									<Box sx={{ flexGrow: 1 }}>
										<span style={{ fontWeight: 'bold', overflowWrap: 'break-word', display: 'inline-block' }}>
											{selectedActivity.title}
										</span>
									</Box>
									{!isXS && (
										<Box sx={{ flexShrink: 0 }}>
											<PaxQtySelector />
										</Box>
									)}
								</Box>
							</Grid>
							<Grid>
								<CloseButton handleClose={handleClose} />
							</Grid>
						</Grid>
					</DialogTitle>
					<DialogContent
						dividers
						sx={{ padding: 0 }}
						ref={(node: HTMLDivElement | null) => {
							setScrollContainerNode(node);
						}}
					>
						<ActivityContent activity={selectedActivity} scrollContainerNode={scrollContainerNode} />
					</DialogContent>
				</>
				)}
			</Dialog>
		</>
	);
}

export default ActivityDialog;